module.exports = __webpack_public_path__ + "img/min.2ccf7bc9.png";